import type { MessageHeader } from '@/api/spec.ts';

export function parseWebSocketMessage(event: MessageEvent): MessageHeader | null {
  let parsedData: any;
  try {
    parsedData = JSON.parse(event.data as string);
  } catch (e) {
    console.error('Failed to parse WebSocket message data:', event.data, e);
    return null;
  }

  if (
    typeof parsedData !== 'object' ||
    parsedData == null ||
    !('mt' in parsedData || 'id' in parsedData || 'data' in parsedData)
  ) {
    console.error('Received bad ws message:', parsedData);
    return null;
  }

  return parsedData as MessageHeader;
}

export function buildWebSocketURL(endpoint: string): string {
  const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
  return `${protocol}://${window.location.host}${endpoint}`;
}
